import actionCreatorFactory from 'typescript-fsa';
import { MediaItem } from './media.reducer';
const actionCreator = actionCreatorFactory('Media');

export const updateMediaEntities = actionCreator<{
  mediaItems: {
    [key: number]: MediaItem;
  };
}>('ENTITIES_UPDATE');

export interface UploadMedia {
  file: File;
  zoneId: string;
}
export const uploadMedia = actionCreator<UploadMedia>('UPLOAD');

export const resetMediaForZoneId = actionCreator<{
  zoneId: string;
}>('RESET');

export const addFailedZoneId = actionCreator<{
  zoneId: string;
}>('FAILED_ADD');

export const removeFailedZoneId = actionCreator<{ zoneId: string }>(
  'FAILED_REMOVE'
);



// WEBPACK FOOTER //
// ./src/store/Entities/Media/media.actions.ts